import {Injectable} from '@angular/core';

@Injectable()
export class CommandsGuiToolbar {
    constructor() {

    }

    createToolBar() {
    }

    disableToolBarItem() {
    }

    enableToolBarItem() {
    }

    setToolBarTips() {
    }
}
